import { Recipe } from '../models/recipe.model';

export const Recipes = {
    0: {
        _id: '0',
        img: {
            landscape: {
                url: './assets/temp-images/IMG_0018_14May17.jpg'
            }
        },
        ingredients : "<div style='direction: rtl;'>מנה אחת<br><ul><li>1 כף צ׳יה</li><li>1/2 כוס חלב קוקוס 5%-7% או 1/3 כוס חלב קוקוס 18% בקרטון</li><li>1/2 כוס מים</li><li>1 כוס פירות יער קפואים</li></ul></div>",
        instractions : "<div style='direction: rtl;'><ol><li>טוחנים את כל המרכיבים בבלנדר או מעבד מזון ידני.</li><li>למרקם &quot;סמודי&quot; מומלץ להקפיא את הפירות לפני הכנת השייק. </li><li>ניתן להוסיף לכל השייקים גם כוס של עלים ירוקים. במקרה זה עדיף להשתמש בבלנדר. </li><li>במידה ואתם רוצים לשפר את פעילות המעיים כדאי להשרות את הצ&rsquo;יה בחלב הקוקוס בלילה ואז טוחנים לשייק עם הפרי בבוקר.</li></ol></div>",
        name : "דיטוקס שייק עם פירות יער",
    },
    1: {
        _id: '1',
        img: {
            landscape: {
                url: './assets/temp-images/IMG_0058_14May17.jpg'
            }
        },
        ingredients : "<div style='direction: rtl;'>מנה אחת<br><ul><li>1 כף צ׳יה</li><li>½ כוס חלב קוקוס 5%-7% או ⅓ כוס חלב קוקוס 18% בקרטון</li><li>½ כוס מים</li><li>½ בננה</li><li>6 תותים</li></ul></div>",
        instractions : "<div style='direction: rtl;'><ol><li>טוחנים את כל המרכיבים בבלנדר או מעבד מזון ידני.</li><li>למרקם &quot;סמודי&quot; מומלץ להקפיא את הפירות לפני הכנת השייק. </li><li>ניתן להוסיף לכל השייקים גם כוס של עלים ירוקים. במקרה זה עדיף להשתמש בבלנדר. </li><li>במידה ואתם רוצים לשפר את פעילות המעיים כדאי להשרות את הצ&rsquo;יה בחלב הקוקוס במהלך הלילה ואז טוחנים לשייק עם הפרי בבוקר.</li></ol></div>",
        name : "דיטוקס שייק עם בננה ותותים"
    },
    2: {
        _id: '2',
        name: 'Recipe 2',
        img: {
            landscape: {
                url: './assets/temp-images/IMG_0080_15May17.jpg'
            }
        }
    },
    3: {
        _id: '3',
        name: 'Recipe 3',
        img: {
            landscape: {
                url: './assets/temp-images/IMG_0095_15May17.jpg'
            }
        }
    },
    4: {
        _id: '4',
        name: 'Recipe 4',
        img: {
            landscape: {
                url: './assets/temp-images/IMG_0140_27May17.jpg'
            }
        }
    },
    5: {
        _id: '5',
        name: 'Recipe 5',
        img: {
            landscape: {
                url: './assets/temp-images/IMG_0284_20May17.jpg'
            }
        }
    },
};

